/* @flow */

export const PAGAMENTO_CARTAO_CREDITO = 1;
export const PAGAMENTO_CARTAO_DEBITO = 2;
export const PAGAMENTO_DINHEIRO_SEM_TROCO = 4;
export const PAGAMENTO_DINHEIRO_COM_TROCO = 8;
export const PAGAMENTO_BOLETO = 16;
export const PAGAMENTO_PAGAMENTO_COM_MAQUININHA_DA_LOJA = 32;
export const PAGAMENTO_JA_REALIZADO = 64;
export const PAGAMENTO_VALE_ALIMENTACAO = 128;
export const PAGAMENTO_SODEXO = 256;
export const PAGAMENTO_ALELO = 512;
export const PAGAMENTO_TICKET = 1024;
